

























































































































































import { Component, Vue } from 'vue-property-decorator';
import { refreshStores } from '@/containers/globals/globalSharedService';
import PageNotFound from '@/containers/pages/PageNotFound.vue';
import ErrorMessagePageTemplate from '@/containers/templates/ErrorMessagePageTemplate.vue';
import PortalAppBar from '@/containers/templates/PortalAppBar.vue';
import { i18n } from '@/plugins/i18n/i18n';
import { listRoles, deleteRole, countUsersInRole } from '@/services/role';
import { isSystemRole } from '@/services/role/roleUtils';
import { commonModule } from '@/store/modules/CommonStore';
import { globalSnackbarModule } from '@/store/modules/GlobalSnackbarStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import { LoginInfo, UserInfo } from '@/types/type';
import { getDisabledRoutes } from '@/utils/CommonUtils';
import { PAGE_PATH_BY_NAME } from '@/utils/consts';

@Component({
  components: {
    ErrorMessagePageTemplate,
    PageNotFound,
    PortalAppBar,
  },
})
export default class RoleManagement extends Vue {
  private roles: any[] = [];
  private loading = true;
  private deleteDialog = false;
  private usersAssignedDialog = false;
  private selectedRole: any = null;
  private userCount = 0;
  private loginInfo!: LoginInfo;
  private isRoleManagementEnabled: boolean = false;

  private notEnabledImgAltMessage: String = 'Page Not Enabled';
  private notEnabledImgName: String = 'page-not-enabled';
  private notEnabledImgWidth: String = '250px';
  private notEnabledImgHeight: String = '186px';

  private headers = [
    {
      text: i18n.tc('commonSetting.roleManagement.roleNameHeader'),
      value: 'name',
    },
    {
      text: i18n.tc('commonSetting.roleManagement.defaultHeader'),
      value: 'isDefault',
    },
    {
      text: i18n.tc('commonSetting.roleManagement.descriptionHeader'),
      value: 'description',
    },
    {
      text: i18n.tc('commonSetting.roleManagement.actionsHeader'),
      value: 'actions',
      sortable: false,
    },
  ];

  async created() {
    // ログイン情報を取得
    this.loginInfo = commonModule.loginInfo;
    await refreshStores(this.loginInfo);

    // 無効化されたルートの取得
    const disabledRoutes = await getDisabledRoutes(
      this.loginInfo.tenant,
      this.loginInfo.landscape,
      this.loginInfo.loginName
    );

    // 現在のページが無効化されていないかチェック
    if (!disabledRoutes.includes(PAGE_PATH_BY_NAME.commonsettingRole)) {
      this.isRoleManagementEnabled = true;
      await this.fetchRoles();
    }

    this.loading = false;
  }

  get userInfo(): UserInfo {
    return loginUserModule.userInfo;
  }

  async fetchRoles() {
    this.loading = true;
    try {
      // テナント・ランドスケープでフィルタリングしてロールを取得
      this.roles = await listRoles(
        this.loginInfo.tenant,
        this.loginInfo.landscape
      );
    } catch (error) {
      globalSnackbarModule.showSnackbarAction(
        this.$t('commonSetting.roleManagement.loadFailed') as string
      );
    } finally {
      this.loading = false;
    }
  }

  navigateToCreateRole() {
    this.$router.push({ name: 'createRole' });
  }

  editRole(id: string) {
    this.$router.push({ name: 'editRole', params: { id } });
  }

  async confirmDelete(role: any) {
    this.selectedRole = role;

    // ロールに所属するユーザー数を確認
    try {
      this.userCount = await countUsersInRole(
        role.id,
        this.loginInfo.tenant,
        this.loginInfo.landscape
      );

      if (this.userCount > 0) {
        // ユーザーが所属している場合は削除を許可しない
        this.usersAssignedDialog = true;
      } else {
        // ユーザーが所属していない場合は削除確認ダイアログを表示
        this.deleteDialog = true;
      }
    } catch (error) {
      globalSnackbarModule.showSnackbarAction(
        this.$t('commonSetting.roleManagement.loadFailed') as string
      );
    }
  }

  async deleteRole() {
    if (!this.selectedRole) return;

    try {
      await deleteRole(this.selectedRole.id);
      globalSnackbarModule.showSnackbarAction(
        this.$t('commonSetting.roleManagement.deleteSuccess') as string
      );
      await this.fetchRoles();
    } catch (error) {
      globalSnackbarModule.showSnackbarAction(
        this.$t('commonSetting.roleManagement.deleteFailed') as string
      );
    } finally {
      this.deleteDialog = false;
      this.selectedRole = null;
    }
  }

  isSystemRole(roleId: string): boolean {
    return isSystemRole(roleId);
  }
}
